import { render, staticRenderFns } from "./Bucket.vue?vue&type=template&id=2fe07624&scoped=true&"
import script from "./Bucket.vue?vue&type=script&lang=js&"
export * from "./Bucket.vue?vue&type=script&lang=js&"
import style0 from "./Bucket.vue?vue&type=style&index=0&id=2fe07624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe07624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/julian/Projects/schmuckli.net/schmucklicloud_console/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VIcon})
